import { Fragment } from 'react';
import { Popover, Transition, PopoverButton, PopoverPanel } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';
import { WEATHER_STATION_ENABLED } from '../config/featureFlags';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/events', label: 'Events' },
  { to: '/tribute', label: 'In Memoriam' },
  { to: '/contact', label: 'Contact' },
];

function Header() {
  return (
    <Popover className="relative z-20 border-b border-[#d8d0be] bg-[#fbf8ef]/95 backdrop-blur">
      <div className="mx-auto max-w-[92rem] px-4 sm:px-6 lg:px-10">
        <div className="flex min-h-20 items-center justify-between gap-6 py-4">
          <Link to="/" className="min-w-0 text-[#10351f]">
            <span className="block font-serif text-2xl leading-none sm:text-3xl">
              Emma's Court
            </span>
            <span className="mt-2 block text-[0.6rem] font-semibold uppercase tracking-[0.42em] text-[#253f2d] sm:text-xs">
              A Community Garden
            </span>
          </Link>

          <div className="-mr-2 md:hidden">
            <PopoverButton className="inline-flex h-11 w-11 items-center justify-center border border-[#cfc7b6] text-[#10351f] transition-colors hover:bg-[#efe7d8] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b]">
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </PopoverButton>
          </div>

          <nav className="hidden items-center justify-end gap-7 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="text-sm font-medium text-[#243c2c] transition-colors hover:text-[#8e3a2b]"
              >
                {item.label}
              </Link>
            ))}
            {WEATHER_STATION_ENABLED && (
              <Link
                to="/weather-station"
                className="text-sm font-medium text-[#243c2c] transition-colors hover:text-[#8e3a2b]"
              >
                Weather Station
              </Link>
            )}
            <Link
              to="/apply"
              className="border border-[#43513f] px-4 py-2 text-sm font-medium text-[#18271e] transition-colors hover:bg-[#10351f] hover:text-[#fbf8ef] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef]"
            >
              Join
            </Link>
          </nav>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 -translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="duration-150 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-2"
      >
        <PopoverPanel focus className="absolute inset-x-0 top-full border-b border-[#d8d0be] bg-[#fbf8ef] shadow-lg md:hidden">
          {({ close }) => (
            <div className="px-4 pb-5 pt-3">
              <div className="mb-2 flex justify-end">
                <PopoverButton className="inline-flex h-11 w-11 items-center justify-center border border-[#cfc7b6] text-[#10351f] hover:bg-[#efe7d8] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b]">
                  <span className="sr-only">Close menu</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </PopoverButton>
              </div>
              <div className="grid gap-2">
                {navItems.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="border-t border-[#d8d0be] px-1 py-3 text-base font-medium text-[#243c2c]"
                    onClick={() => close()}
                  >
                    {item.label}
                  </Link>
                ))}
                {WEATHER_STATION_ENABLED && (
                  <Link
                    to="/weather-station"
                    className="border-t border-[#d8d0be] px-1 py-3 text-base font-medium text-[#243c2c]"
                    onClick={() => close()}
                  >
                    Weather Station
                  </Link>
                )}
                <Link
                  to="/apply"
                  className="mt-3 flex items-center justify-between border border-[#43513f] px-4 py-3 text-base font-medium text-[#18271e]"
                  onClick={() => close()}
                >
                  <span>Join</span>
                  <span aria-hidden="true">&rarr;</span>
                </Link>
              </div>
            </div>
          )}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
}

export default Header;
